(() => {
  const config = document.currentScript;
  const root = config?.dataset.bkMarketRoot?.replace(/\/$/, '');
  const shopCurrency = config?.dataset.bkShopCurrency;
  if (!root || !shopCurrency) return;

  if (!customElements.get('bk-shipping-threshold')) {
    customElements.define('bk-shipping-threshold', class extends HTMLElement {
      connectedCallback() {
        const currency = window.Shopify?.currency;
        const rate = currency?.active === shopCurrency ? 1 : Number(currency?.rate);
        if (!currency?.active || !Number.isFinite(rate) || rate <= 0) return;
        const amount = Math.round(Number(this.dataset.amount) * rate * 100) / 100;
        if (!Number.isFinite(amount)) return;
        const formatted = new Intl.NumberFormat(document.documentElement.lang, {
          style: 'currency', currency: currency.active
        }).format(amount);
        this.textContent = this.dataset.template.replace('__AMOUNT__', formatted);
      }
    });
  }

  const checkoutUrl = link => {
    const href = link.getAttribute('href');
    if (!href) return null;
    let url;
    try { url = new URL(href, location.origin); } catch { return null; }
    if (url.origin !== location.origin) return null;
    const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '');
    if (path !== '/apps/checkout' && !link.matches('.kaching-cart__checkout-button, #kaching-cart__checkout-button')) return null;
    url.pathname = '/apps/checkout';
    url.searchParams.set('lng', 'en-ro');
    return url.pathname + url.search + url.hash;
  };

  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    const next = checkoutUrl(link);
    if (!next) return;
    link.setAttribute('href', next);
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(next);
  }, true);

  const localize = link => {
    const checkout = checkoutUrl(link);
    if (checkout) {
      if (link.getAttribute('href') !== checkout) link.setAttribute('href', checkout);
      return;
    }
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    let url;
    try { url = new URL(href, location.origin); } catch { return; }
    if (url.origin !== location.origin) return;
    const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '');
    if (path !== '' && path !== '/' && !/^\/(products|collections|pages|blogs|search)(\/|$)/.test(path)) return;
    const next = root + (path === '/' ? '' : path) + url.search + url.hash;
    if (href !== next) link.setAttribute('href', next);
  };
  const scan = node => {
    if (!(node instanceof Element)) return;
    if (node.matches('a[href]')) localize(node);
    for (const link of node.querySelectorAll('a[href]')) localize(link);
  };
  scan(document.documentElement);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') localize(record.target);
      else for (const node of record.addedNodes) scan(node);
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
})();
